import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "7bb13Ky4ztJN6UBlmZrxR9F", "n_touch", undefined);

import { _decorator, Component, v2, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property;

var n_touch = ccclass(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(n_touch, _Component);

  function n_touch() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_speed", v2(0, 0));

    _defineProperty(_assertThisInitialized(_this), "_baseSpeed", 100);

    _defineProperty(_assertThisInitialized(_this), "_curSpeed", 100);

    _defineProperty(_assertThisInitialized(_this), "_n_wheel", null);

    _defineProperty(_assertThisInitialized(_this), "_posInit_wheel", v3());

    _defineProperty(_assertThisInitialized(_this), "_n_wheelCenter", null);

    _defineProperty(_assertThisInitialized(_this), "_n_wheelDir", null);

    _defineProperty(_assertThisInitialized(_this), "_pos_touch", null);

    _defineProperty(_assertThisInitialized(_this), "_pos_pre", null);

    _defineProperty(_assertThisInitialized(_this), "_noEnergyTime", 0);

    return _this;
  }

  var _proto = n_touch.prototype;

  _proto.onLoad = function onLoad() {
    this._n_wheel = this.node.getChildByName("a_n_wheel");
    this._posInit_wheel = v3(this._n_wheel.position);
    this._n_wheelCenter = this._n_wheel.getChildByName("a_n_wheelCenter");
    this._n_wheelDir = this._n_wheel.getChildByName("dir_arrow");
    this._n_wheel.active = false;
  };

  _proto.start = function start() {}
  /**更新角色速度 */
  ;

  _proto.updateSpeed = function updateSpeed(v) {} // update (dt) {}
  ;

  return n_touch;
}(Component), _temp)) || _class;

export { n_touch as default };

_cclegacy._RF.pop();